import * as React from "react";
import { Box } from "@mui/material";
import Modal from "@mui/material/Modal";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "1296px",
  width: "80%",
  backgroundColor: "#FFFFFF",
};

export default function CustomModal({ children,width,handleClose, isOpened }) {

  return (
    <div>
      <Modal
        open={true}
        onClose={handleClose}
        scroll={""}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} style={{width:width}}>
          <Box p={4}>{children}</Box>
        </Box>
      </Modal>
    </div>
  );
}
